import React from "react";
import { Link } from "react-router-dom";
import { Drawer, DrawerContent, DrawerItem } from "@progress/kendo-react-layout";
import { MsalContext } from "@azure/msal-react";

const CustomItem = (props) => {
	function navigate(e) {
		e.preventDefault();
		const { onSelect, index, ...itemProps } = props;
		onSelect(itemProps, index);
	}

	const className = "w-100 " + (props.position === "Bottom" && " bottom-0 position-absolute");

	return (
		<Link className={className} to={props.route || "#"} onClick={navigate}>
			<DrawerItem {...props} onSelect={(e) => { }}>
				{!props.showText && <span>&nbsp;</span>}
				<i className={props.icon}></i>
				{props.showText && <span>{props.text}</span>}
			</DrawerItem>
		</Link>
	);
};

class SubscriptionDrawer extends React.Component {

	static contextType = MsalContext

	constructor(props) {
		super(props);
		this.state = {
			expanded: true,
			items: [
				{ text: "Subscription Type", icon: "fas fa-money-check-dollar", selected: true, route: `/_SubscriptionManagement`, className: "k-drawer-item" },
				// { text: "Search Organization", icon: "fas fa-search", route: `/_SearchOrganization` }
			],
			selectedId: 0,
		}
	}

	handleClick = (e) => {
		let items = this.state.items
		if (e.itemTarget.text === "Close") {
			items[5].show = true;
			items[4].show = false;
		}
		if (e.itemTarget.text === "Open") {
			items[5].show = false;
			items[4].show = true;
		}
		this.setState({
			items: items,
			expanded: !this.state.drawerExpanded,
		});
	};

	onSelect = (e) => {
		this.setState({
			selectedId: e.itemIndex || 0,
			expanded: this.state.drawerExpanded
		});
		this.props.history.push(e.itemTarget ? e.itemTarget.route : e.route);
	};

	setSelectedItem = (pathName) => {
		let currentPath = this.state.items.find((item) => item.text === pathName);
		if (currentPath && currentPath.text) {
			return currentPath.text;
		} else {
			this.onSelect(this.state.items[0])
		}
	};

	drawerProps = {
		position: "start",
		mode: "push",
		mini: true,
	};

	handleResize = () => {
		if (window.innerWidth < 1100) {
			if (this.state.drawerExpanded) this.setState({ drawerExpanded: false });
		} else {
			if (!this.state.drawerExpanded) this.setState({ drawerExpanded: true });
		}
	};

	componentDidMount() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	render() {
		const data = this.state.items.map((item) => {
			item.showText = this.state.drawerExpanded;
			return item;
		});

		let selected = this.setSelectedItem(this.props.selected);
		return (
			<Drawer
				className="organization-drawer"
				expanded={this.state.drawerExpanded}
				animation={false}
				items={data.map((item) => ({
					...item,
					selected: item.text === selected,
					showText: this.state.drawerExpanded,
				}))}
				{...this.drawerProps}
				item={CustomItem}
				onSelect={this.onSelect}
			>
				<DrawerContent className="w-100 h-100">{this.props.children}</DrawerContent>
			</Drawer>
		);
	}
}

export default SubscriptionDrawer;
